import React, {useMemo} from 'react';
import {ChartQuery} from 'entities/chart';
import {ChartType} from '@/views/storyboard/utils/chartConstants';
import {InlineAlert} from '@/components/alerts';
import {getChartSettingsCompatibilityHints} from '@/views/storyboard/chart_settings/chartSettingsCompatibilityHints';

interface Props {
    chartType: ChartType;
    chartQuery: ChartQuery;
}

const ChartSettingsCompatibilityHintsPanel = React.memo<Props>(({chartType, chartQuery}) => {
    const hints = useMemo(
        () => getChartSettingsCompatibilityHints(chartType, chartQuery),
        [chartType, chartQuery.output, chartQuery.aggs_item_list],
    );

    if (!hints.length) {
        return null;
    }

    return (
        <div className="chart-settings-compatibility-hints">
            {hints.map((hint) => (
                <InlineAlert
                    key={hint.message}
                    variant={hint.variant}
                    icon={hint.variant === 'error' ? 'mdi-alert-circle-outline' : 'mdi-information-outline'}
                    message={hint.message}
                    className="chart-settings-compatibility-hints__item"
                />
            ))}
        </div>
    );
});

export default ChartSettingsCompatibilityHintsPanel;
